__turbopack_context__.v({
  "boxOne": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__boxOne",
  "boxOneContent": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__boxOneContent",
  "colorPink": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__colorPink",
  "dataContainer": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__dataContainer",
  "dataEntry": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__dataEntry",
  "dataValue": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__dataValue",
  "markdownSection": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__markdownSection",
  "sectionTitle": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__sectionTitle",
  "separator": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__separator",
  "separatorThick": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__separatorThick",
  "title": "bento-rectangle-broadband-facts-module-scss-module__C1GfDG__title",
});
